"use client";
import { useEffect, useState } from "react";
import TypographyMontserrat from "../../Atoms/TypographyMontserrat";
import { sendGTMEvent } from "@next/third-parties/google";
import NewFilterCheckbox from "@/components/Atoms/Inputs/InputField/NewFilterCheckbox";

export const TextBoxFilterOption = ({
    filterSelected,
    option,
    toggleFilters = () => {},
}) => {
    return (
        <div
            className={
                "w-10 h-10 border border-New_Primary_Default rounded-sm flex items-center justify-center cursor-pointer transition-all duration-200 " +
                (filterSelected ? " bg-black " : "")
            }
            onClick={toggleFilters}
        >
            <TypographyMontserrat
                customStyle={
                    " !text-sm sm:!text-base uppercase" +
                    (filterSelected ? " !text-white" : "")
                }
                fontWeight={"medium"}
                text={option?.value}
            />
        </div>
    );
};

export const ColorFilledFilterOption = ({
    filterSelected,
    toggleFilters = () => {},
    color,
}) => {
    return (
        <div
            className={
                ` w-10 h-10 border-2 border-transparent rounded-sm cursor-pointer transition-all duration-200 ` +
                (filterSelected ? " !border-black p-[3px] " : "")
            }
            onClick={toggleFilters}
        >
            <div
                className="w-full h-full rounded-sm"
                style={{ backgroundColor: color }}
            />
        </div>
    );
};

export const CheckboxFilterOption = ({
    filterSelected,
    label,
    toggleFilters = () => {},
}) => {
    const [checked, setChecked] = useState(filterSelected);

    useEffect(() => {
        setChecked(filterSelected);
        filterSelected
            ? sendGTMEvent({
                  event: "FiltersInteraction",
                  menu_name: label,
                  place: "ProductFilter",
              })
            : null;
    }, [filterSelected]);

    return (
        <div className="flex gap-x-2">
            <NewFilterCheckbox
                type={"checkbox"}
                checked={checked}
                label={String(label)}
                onChange={toggleFilters}
            />
        </div>
    );
};
